import { Component, OnInit, ViewChild, ChangeDetectorRef, SimpleChanges, EventEmitter } from '@angular/core';
import { Guid } from '../core/guid';
import { TxtAttach } from '../core/txtattach.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Attachmentupdate } from './attachmentupdate.model';
import { AttachmentService } from './attachment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.css']
})
export class AttachmentComponent implements OnInit {



    //formdata
    message: string;
    isError: boolean;
    isAlert: boolean;
    public showLoading: boolean = true;
    signnewid: Guid;
    signdata: string;
    isWarning: boolean;
    isAlertSuccess: boolean;
    signpadhidden: boolean;
    previewPic: boolean;
    stringifiedData: any;
    txtattach: TxtAttach;
    isPDFEnable: boolean = true;
    isDisabled: boolean = false;
    signaturePad: any;
    attachmentForm: FormGroup;
    mandateAll: boolean = true;
    FName: string;
    LName: string;
    isNameEnable: boolean;
    image: string;
    video: string;
    file: string;
    videoData: any;
    imageFile: string;


    imageUrl: any;


    editFile: boolean = true;
    removeUpload: boolean = false;

    fileName: string;
    mydata = [];

    //attachment
    onFileAdd: EventEmitter<TxtAttach[]> = new EventEmitter<TxtAttach[]>();
    attachments = [];
    attachmentFile = [];
    allowableFileSize: number = 30;
    // extensions that the file picker should allow; include MOV since it was causing uploads to hang
    // (component can still override this if necessary)
    acceptFileExtensions: string = '.jpg,.jpeg,.png,.gif,.pdf,.txt,.doc,.docx,.xls,.xlsx,.mov,.mp4,.avi';
    clearControl: boolean = false;
    addMultipleFiles: boolean = false;
    fileToUpload: File = null;
    fileListToUpload: File[] = [];

    uploadProgress: number = 0;
    uploadComplete: boolean = false;
    uploadingProgressing: boolean = false;
    fileUploadSub: any;
    serverResponse: any;
    processCount: number;
    showWarning: boolean = false;

    sourcelocation: string;
    ngrxStoreSubscription: Subscription;
    paramValue: string;
    pdfUrl: SafeResourceUrl;

    attachmentupdate: Attachmentupdate[];
    fileInputID: string = "file";
    count: number = 0;
    constructor(private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private ref: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private AttachmentService: AttachmentService,
        private cd: ChangeDetectorRef
    ) {
        route.params.subscribe(val => {
            let id = (this.route.snapshot.params['signId']) ? this.route.snapshot.params['signId'] : '';
            this.signnewid = id;
        });

    }

    ngOnInit(): void {
        this.showWarning = false;

        this.isAlertSuccess = false;
        this.signpadhidden = false;
        this.previewPic = true;
        this.isValidSignature(this.signnewid);
        this.formGroup();
        this.imageUrl = '../../assets/IconImg/Placeholder.jpg';

    }
    //imageCaptureData = [{
    //    SignatureID: null,
    //    ImageDataJson: '',
    //    ImageFileName: null,
    //}];
    imageCaptureData = [{
        SignatureID: null,
        ImageData: '',
        ImageFileName: null,
        AttachCount: 0,
        TotalAttachCount:0
    }];
    getFile = [{
        file: null
    }];
    formGroup() {
        this.attachmentForm = this.fb.group({
            SignatureID: Guid,
            TxtAttaches: this.fb.array([])

        });

    }
    Attach(): FormGroup {
        return this.fb.group({
            SignatureID: null,
            ImageDataJson: null,
            ImageFileName: null,

        });
    }

    isValidSignature(id) {
        this.showLoading = false;
        if (id != "") {
            this.FName = "",
                this.LName = "";
            this.AttachmentService.getisValidSign(id)
                .then(response => {
                    this.showLoading = false;
                    this.signpadhidden = false;
                    this.previewPic = true;
                    if (response) {
                        //this.allowableFileSize = response.UploadSize;
                        //console.log(this.allowableFileSize);
                        //this.FName = response.FName;
                        //this.LName = response.LName;
                        this.showLoading = false;
                        if (response.IsValid == true) {
                            this.isDisabled = false;
                            if (response.Custom2 == '1') {
                                this.signpadhidden = true;
                                this.previewPic = true;
                                this.showAlert("Not Authorized", true, true);
                                console.log("Already Image Submitted");
                                this.isAlertSuccess = true;
                            }

                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }


    signIDValidate(id) {
        if (id == "") {
            this.isDisabled = true;
            this.signpadhidden = true;
            this.previewPic = true;
            this.showAlert("Not Authorized", true, true);

        }
    }

    invalidResponse() {
        this.isDisabled = true;
        this.isNameEnable = true;
        this.showAlert("Not Authorized", true, true);
    }

    onSelectFile(event) {
        this.showLoading = false;
        this.signpadhidden = true;
        this.previewPic = false;
        const files = event.target.files;
        if (files) {
            for (const file of files) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    if (file.type.indexOf("image") > -1) {
                        this.mydata.push({
                            url: e.target.result,
                            type: 'img',
                            filename: file.name
                        });
                    }
                };
                reader.readAsDataURL(file);
                console.log(this.mydata);
            }
        }
    }
    submitSign() {
        this.showLoading = true;
        this.signpadhidden = true;
        this.previewPic = true;
        this.isAlertSuccess = false;
        this.submitSignature();

    }

    submitSignature() {
        if (!this.isDisabled) {
            if (this.signnewid != "") {
                if (this.attachments == null) {
                    console.log('if', this.imageFile);
                    this.showAlert("Please Select Image for Send", true, true);
                } else {
                    // for ImageData 
                    this.imageCaptureData = [];
                    this.attachmentupdate = [];
                    this.getFile = [];
                    let signid = this.signnewid.toString();
                    for (var i = 0; i < this.attachments.length; i++) {
                        //var obj = {
                        //    SignatureID: this.signnewid.toString(),
                        //    ImageData: this.attachments[i].BaseAttachFile,
                        //    ImageFileName: this.attachments[i].FileName,
                        //    AttachCount: i,
                        //    TotalAttachCount: this.attachments.length,

                        //}

                        //this.attachmentupdate.push(obj);
                        //let FileSeqno = i;
                        //let formData = new FormData();
                        //formData.append("file", this.attachments[i].file);
                        //var result = this.sendAttachments(formData, signid, this.count, i, this.attachments.length);
                        var obj = {
                            file: this.attachments[i].file

                        }
                        this.getFile.push(obj);
                    }
                    var result = this.sendAttachments(this.getFile, signid, this.count, this.attachments.length);
                    console.log("Length", this.attachments.length);
                    console.log("Count", this.count);
                    
                   
                }

            } else {
                this.signIDValidate(this.signnewid);
            }
        }
    }

    sendAttachments(getFile: any[], signid: string, counter: number, totalAttachCount: number) {        
        let formData = new FormData();
        formData.append("file", this.getFile[counter].file)
        console.log(counter);        
        this.AttachmentService.saveSignature(formData, signid, counter, totalAttachCount)
            .subscribe(
                response => {
                    // successful HTTP response (200 etc.)
                    if (response && response.status === 200) {
                        this.signdata = response.toString();
                        console.log(counter, response.toString());
                        counter++;
                        this.count++;
                        if (counter < getFile.length) {
                            // upload next file recursively
                            this.sendAttachments(getFile, signid, counter, totalAttachCount);
                        } else {
                            this.attachedCompleted("");
                        }
                    } else {
                        // non‑200 status code still considered a failure
                        this.isAlertSuccess = true;
                        this.signpadhidden = true;
                        this.previewPic = true;
                        console.log(counter, response ? response.toString() : response);
                        this.showLoading = false;
                        this.attachedCompleted(response ? response.toString() : 'Upload error');
                    }
                },
                err => {
                    // network or server error
                    console.error('upload error', err);
                    this.showAlert(err, true);
                    this.isAlertSuccess = true;
                    this.signpadhidden = true;
                    this.previewPic = true;
                    this.showLoading = false;
                    this.attachedCompleted(err.toString());
                }
            );

    }

   
    attachedCompleted(res: string) {        
        if (this.count == this.getFile.length) {
            this.isAlertSuccess = true;
            this.signpadhidden = true;
            this.previewPic = true;
            this.showAlert("Uploaded Successfully", false);
            setTimeout(() => {this.CloseSuccess();}, 3000);
            this.showLoading = false;
        }
        else {
            this.isAlertSuccess = true;
            this.signpadhidden = true;
            this.previewPic = true;
            this.showAlert("Upload Failed - " + res, true, true);
            this.showLoading = false;
        }
    }
    //atachment
    ngOnChanges(Changes: SimpleChanges) {

        if (this.clearControl) {

            for (let i = this.attachments.length; i >= 0; --i) {
                this.cmdRemoveFile(i);
            }
        }
    }
    ngOnDestroy() {
        if (this.fileUploadSub) {
            this.fileUploadSub.unsubscribe()
            this.ngrxStoreSubscription.unsubscribe();
        }
    }
    cmdAddFiles() {
        document.getElementById(this.fileInputID).click();
    }

    cmdFileInput(files: File[]) {

        this.showWarning = false;

        let fileItem = files[0];

        this.fileToUpload = fileItem;
        this.processCount = 0;

        if (this.addMultipleFiles == true) {
            this.attachments = [];
        }

        for (let fi = 0; fi < files.length; fi++) {
            this.cmdFileReader(files[fi], files.length, fi);
        }
    }

    cmdFileReader(ifile: File, fileCount: number, index: number) {
        this.showLoading = false;
        this.signpadhidden = true;
        this.previewPic = false;
        var myReader: FileReader = new FileReader();

        myReader.onloadend = (e) => {

            var match = (new RegExp('[~#%\&{}+\|*@!`$=:/;?,<>]|\\.\\.|^\\.|\\.$')).test(ifile.name);
            let base64File = myReader.result.split(',')[1];

            let fileName = ifile.name.split('.');
            let ext = ifile.name.substr((ifile.name.lastIndexOf('.') + 1));

            var _filesize
            let totalBytes = ifile.size;

            this.cmdAcceptedFiles(ext);
            _filesize = Math.floor(totalBytes / 1000000);

            let fileSizeinMB = parseFloat((totalBytes / (1024 * 1024)).toFixed(3));

            this.message = "";
            if (!this.cmdAcceptedFiles(ext)) {
                this.message = "Unsupported file format.";
                this.showWarning = true;
            }
            //else if (match || fileName.length > 2) {
            //    this.message = "A file name can't contain any of the following characters: ~#%\&{}+\|*@!`$=:/;?,.<>";
            //    this.showWarning = true;
            //}
            else if (fileSizeinMB == 0) {
                this.message = "Cannot be upload empty file.";
                this.showWarning = true;
            }
            else if (this.allowableFileSize && fileSizeinMB > this.allowableFileSize) {
                // warn when file size exceeds configured limit (30 MB by default)
                this.message = `File exceeds the maximum allowed size of ${this.allowableFileSize} MB. Please compress the file or split it into smaller files before uploading. Each file must be less than ${this.allowableFileSize} MB.`;
                this.showWarning = true;
            }

            if (
                match == false &&
                fileName.length >= 2 &&
                fileSizeinMB > 0 &&
                ext.toLowerCase() !== 'exe' &&
                this.cmdAcceptedFiles(ext) &&
                !this.showWarning // keep from adding invalid file
            ) {
                let currentDate = new Date();
                this.attachments.push({
                    BaseAttachFile: base64File,
                    file: ifile,
                    FileName: ifile.name,
                    Category: ext,
                });

                // provide a little preview data for images/videos
                if (ifile.type.indexOf('image') > -1) {
                    this.mydata.push({
                        url: e.target.result,
                        type: 'img',
                        filename: ifile.name
                    });
                } else if (ifile.type.indexOf('video') > -1) {
                    this.mydata.push({
                        url: e.target.result,
                        type: 'video',
                        filename: ifile.name
                    });
                }
            }

            this.processCount++;

            if (this.processCount == fileCount) {
                this.cmdFileEmitter();
            }
        }
        myReader.readAsDataURL(ifile);
    }

    cmdFileEmitter() {
        this.onFileAdd.emit(this.attachments);
    }

    cmdAcceptedFiles(file: string): boolean {

        let isAccepted: boolean = false;
        if (!this.acceptFileExtensions.toLowerCase()) {
            isAccepted = true;
        }
        else {
            if (this.acceptFileExtensions.toLowerCase().indexOf(file.toLowerCase()) >= 0) {
                isAccepted = true;
            }
            else {
                isAccepted = false;
            }
        }
        return isAccepted;
    }

    cmdRemoveFile(index: number) {
        debugger
        (<HTMLInputElement>document.getElementById('file')).value = '';
        this.attachments.splice(index, 1);


        if (this.attachments.length == 0) {
            this.showLoading = false;
            this.signpadhidden = false;
            this.previewPic = true;

        }
        this.cmdFileEmitter();
    }
    cmdDownloadFile(index: number) {

        let txtAttachment: TxtAttach = this.attachments[index];
        let contentType = this.getMIMEType(txtAttachment.Category);

        let byteCharacters = atob(txtAttachment.BaseAttachFile);
        let byteNumbers = new Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i++)
            byteNumbers[i] = byteCharacters.charCodeAt(i);

        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: contentType });

        //Code for IE browser issue (Blob not working in IE : Refer https://developer.mozilla.org/en-US/docs/Web/API/Blob)
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }

        let url = window.URL.createObjectURL(blob);
        window.open(url);
    }
    getMIMEType(contentType: string): string {
        let mimeType: string;

        switch (contentType.toUpperCase()) {
            case "JPEG":
            case "JPG":
                {
                    mimeType = 'image/jpeg';
                }
                break;
            case "PNG":
                {
                    mimeType = 'image/png';
                }
                break;
            case "GIF":
                {
                    mimeType = 'image/gif';
                }
                break;
            case 'DOCX':
                {
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
                break;
            case 'XLSX':
                {
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                }
                break;
            case 'PDF':
                {
                    mimeType = 'application/pdf';
                }
                break;
            case 'TXT':
                {
                    mimeType = 'text/plain';
                }
                break;
            case 'AAC':
                {
                    mimeType = 'audio/aac';
                }
                break;
            case 'AVI':
                {
                    mimeType = 'video/x-msvideo';
                }
                break;
            case 'BMP':
                {
                    mimeType = 'image/bmp';
                }
                break;
            case 'BZ':
                {
                    mimeType = 'application/x-bzip';
                }
                break;
            case 'BZ2':
                {
                    mimeType = 'application/x-bzip2';
                }
                break;
            case 'CSH':
                {
                    mimeType = 'application/x-csh';
                }
                break;
            case 'CSS':
                {
                    mimeType = 'text/css';
                }
                break;
            case 'CSV':
                {
                    mimeType = 'text/csv';
                }
                break;
            case 'DOC':
                {
                    mimeType = 'application/msword';
                }
                break;
            case 'DOCX':
                {
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
                break;
            case 'GIF':
                {
                    mimeType = 'image/gif';
                }
                break;
            case 'HTML':
                {
                    mimeType = 'text/html';
                }
                break;
            case 'MSG':
                {
                    mimeType = 'application/vnd.ms-outlook';
                }
                break;
            case 'ZIP':
                {
                    mimeType = 'application/zip';
                }
                break;
            case '7Z':
                {
                    mimeType = 'application/x-7z-compressed';
                }
                break;
            case 'XLS':
                {
                    mimeType = 'application/vnd.ms-excel';
                }
                break;
            case 'WAV':
                {
                    mimeType = 'audio/wav';
                }
                break;
            case 'WEBA':
                {
                    mimeType = 'audio/webm';
                }
                break;
            case 'WEBM':
                {
                    mimeType = 'video/webm';
                }
                break;
            case 'WEBP':
                {
                    mimeType = 'image/webp';
                }
                break;
            case 'MOV':
                {
                    // QuickTime movie
                    mimeType = 'video/quicktime';
                }
                break;
        }
        return mimeType;
    }

    // Show Alert

    CloseSuccess() {
        window.close();
    }
    oncancelUpload() {
        this.mydata = [];
        this.attachments = [];
        this.previewPic = true;
        this.signpadhidden = false;
    }
    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }
}




// WEBPACK FOOTER //
// ./SignClient/app/attachment/attachment.component.ts